let windowScrollTop = 0;
let productButtonOffsetTop = 0;
const $productButton = $('.js-product-add-to-cart');

$(window).on('load resize orientationchange', function () {
  if ($productButton.length) {
    productButtonOffsetTop = $productButton.offset().top + $productButton.outerHeight();
  }
});

$(window).on('load scroll', function () {
  windowScrollTop = $(window).scrollTop();

  $('body').toggleClass(
    'show-sticky-add-to-cart',
    windowScrollTop + $('.js-header-content').outerHeight() > productButtonOffsetTop &&
      windowScrollTop + $(window).height() < $('.js-footer').offset().top + $('.js-footer').outerHeight() - 200
  );

  $('body').toggleClass(
    'hide-sticky-total',
    windowScrollTop + $(window).height() > $('.js-footer').offset().top + $('.js-footer').outerHeight() - 200
  );
});

$(document).on('click', '.js-sticky-add-to-cart', function (event) {
  event.preventDefault();

  $productButton.trigger('click');
});
